export default function _str(string) {
	if (typeof window !== "undefined" && window._str) {
		return window._str(string);
	}

	return string;
}



// WEBPACK FOOTER //
// ./src/shared/util/_str.js